















































import ValidationErrors from '../../ValidationErrors'
import { Option, Select, Button } from 'element-ui'
import { KisweSelectOption } from '../../../types'
import { defineComponent } from '@vue/composition-api'
import './KisweSelect.scss'
import { generateRandomString } from '@/modules/common/utils'
import { Validation } from '@vuelidate/core'
import { useFlexbox, useSelect, useSizes, useThemes } from '../../../compositions'


export default defineComponent({
  name: 'KisweSelect',
  components: {
    'el-select': Select,
    'el-option': Option,
    'el-button': Button,
    ValidationErrors
  },
  props: {
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    hasLabelEffect: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: [String, Number, Array as () => string[]],
      required: false,
      default: ''
    },
    options: {
      type: Array as () => KisweSelectOption[],
      required: true
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    confirmButton: {
      type: String,
      required: false,
      default: ''
    },
    tooltip: {
      type: String,
      required: false
    },
    validator: {
      type: Object as () => Validation,
      required: false
    },
    isFilter: {
      type: Boolean,
      required: false,
      default: false
    },
    popperClass: {
      type: String,
      required: false,
      default: ''
    },
    isClearable: {
      type: Boolean,
      required: false,
      default: false
    },
    ...useFlexbox().props,
    ...useSelect().props,
    ...useSizes().props,
    ...useThemes().props
  },
  emits: {
    clear () { return true }
  },
  data: () => ({
    id: `kiswe-select--${ generateRandomString(12, false) }`
  }),
  computed: {
    placeholderValue (): string {
      return this.placeholder ?? 'Select'
    },
    selectedValue: {
      get (): number|string|string[] {
        return this.value
      },
      set (newVal: number|string|string[]) {
        this.$emit('input', newVal)
      }
    },
    classList (): string[] {
      const classList = [`theme-${ this.theme }`, `size-${ this.size }`]
      if (this.isFilter) classList.push('filter')
      if (this.hasLabelEffect) classList.push('label-effect')
      return ['kiswe-select', ...classList.map((c) => `kiswe-select--${ c }`)]
    }
  },
  mounted () {
    if (this.validator) {
      console.warn('You are using the old "validator" prop. Please set the ValidationErrors component in ' +
        'the "errors" slot on KisweFormField instead.')
    }
  },
  methods: {
    onChange (event: Event) {
      this.$emit('change', event)
    },
    onClear () {
      this.$emit('clear')
    }
  }
})
